'use strict';

var App = require('app');
var AppState = require('app_state');
var i18n = require('utils/i18n');
var Consts = require('consts');
var Misc = require('utils/misc');
var ModeSelectorView = require('components/devices/views/controller/remote_control_mode_selector');
var RemoteDevice = require('models/remote_device');
var RemoteControlStatusView = require('components/devices/views/controller/remote_control_status');

var RemoteControlView = Marionette.LayoutView.extend({
    model: {},
    screenHeightChange: {},
    isRemoved: undefined,
    mobileWidth: 480,
    maxRefreshInterval: 2500,
    getStatusMessages: function (key) {
        var obj = {
            not_connected: { text: i18n.TR('Nicht verbunden'), labelClass: 'label-default' },
            connecting: { text: i18n.TR('Die Verbindung wird hergestellt'), labelClass: 'label-warning' },
            stopping: { text: i18n.TR('Die Übertragung wird gestoppt'), labelClass: 'label-warning' },
            connected: { text: i18n.TR('Die Übertragung läuft'), labelClass: 'label-success' },
            sending: { text: i18n.TR('Kommando verschickt'), labelClass: 'label-success' },
            error: { text: i18n.TR('Ein Fehler ist aufgetreten'), labelClass: 'label-danger' },
            error_reconnecting: {
                text: i18n.TR('Fehler. Die Bildschirmübertragung wird wiederhergestellt'),
                labelClass: 'label-danger',
            },
            invalid_device: { text: i18n.TR('Die Übertragung läuft mit anderem Gerät'), labelClass: 'label-warning' },
        };

        return obj[key];
    },
    regions: {
        statusBar: '.js-remote-control-status',
    },
    eventQueue: {
        knobRotatingValue: undefined,
        knobDown: 1,
        knobUp: 2,
        knobRotate: 3,
        knobDownTime: {
            triggered: undefined,
            processed: undefined,
        },
        list: [],
        lastCmd: undefined,
        now: undefined,
        add: function (cmd, value) {
            // prevent "up" event from repeating
            if (cmd == this.knobUp) {
                if (this.lastCmd == this.knobUp) return;
            }
            this.updateCurrentTime();

            var doAdd = true;
            this.lastCmd = cmd;
            switch (cmd) {
                case this.knobRotate:
                    if (this.list.length > 0 && this.list[this.list.length - 1].cmd === this.knobRotating)
                        doAdd = false;
                    this.knobRotatingValue = value;
                    break;
                case this.knobUp:
                    value = {
                        rotating: this.knobRotatingValue,
                        lastDown: this.knobDownTime.triggered,
                    };

                    break;
                case this.knobDown:
                    this.knobRotatingValue = undefined;
                    this.knobDownTime.triggered = this.now;
                    break;
            }

            if (doAdd) {
                this.list.push({
                    dt: new Date().getTime(),
                    cmd: cmd,
                    value: value,
                });
                this.activateTimer();
            }
        },

        processQueue: function () {
            var self = this;
            this.updateCurrentTime();

            // is the queue empty? give up
            if (this.list.length === 0) {
                return;
            }

            var firstItem = this.list[0];
            // process a command. When "knob down", wait 1s (time window for rotating the knob. When no rotation until 1s: the user wants to press it)
            if (firstItem.cmd != this.knobDown || this.now - firstItem.dt > 1000 || this.list.length > 1) {
                this.list.shift();
                switch (firstItem.cmd) {
                    case this.knobDown:
                        if (this.list.length === 0 || this.list[0].cmd != this.knobRotate) {
                            this.owner.knobDown();
                            this.knobDownTime.processed = this.now;
                        }
                        break;
                    case this.knobUp:
                        if (firstItem.value.rotating) this.owner.knobSet(firstItem.value.rotating);
                        else
                            setTimeout(
                                function () {
                                    self.updateCurrentTime();
                                    self.owner.knobUp();
                                },
                                firstItem.dt - firstItem.value.lastDown - (self.now - self.knobDownTime.processed)
                            );
                        break;
                }
            }

            if (this.list.length === 0) {
                return;
            }

            // next timer step?
            var defaultTimeStep = 50;
            if (this.list.length > 0) defaultTimeStep = Math.max(defaultTimeStep, this.list[0].dt - firstItem.dt);
            setTimeout(function () {
                self.processQueue();
            }, defaultTimeStep);
        },

        activateTimer: function () {
            this.processQueue();
        },

        updateCurrentTime: function () {
            this.now = new Date().getTime();
        },
    },
    events: {
        'mousedown .remote-device-button-prog': function () {
            this.remoteDevice.command({
                cmd: Consts.RemoteControlCmd.ProgDown,
            });
        },
        'mouseup .remote-device-button-prog': function () {
            this.remoteDevice.command({
                cmd: Consts.RemoteControlCmd.ProgUp,
            });
        },
        'mouseup button.remote-device-knob-button': function (e) {
            this.knobSet($(e.target).closest('button').data('step-count'));
        },
        'click .js-btn-run': function () {
            if (this.isStopping) return;

            var self = this;
            this.isStarting = new Date();
            setTimeout(function () {
                if (self.isStarting) {
                    var diff = new Date().getTime() - self.isStarting.getTime();
                    if (diff >= self.startTimeout) self.isStarting = false;
                }
                self.disableButtons();
            }, this.startTimeout);
            this.refreshStatusLights();
            this.disableButtons();
            this.displayStatus('connecting');
            this.remoteDevice.start(
                function () {
                    if (self.isRemoved) return;
                    self.isStarting = false;
                    self.isStopping = false;
                    self.refresh(true);
                    self.disableButtons();
                    self.displayStatus('connected');
                },
                function () {
                    self.isStarting = false;
                    self.isStopping = false;
                    self.refreshActive = false;
                    if (self.isRemoved) return;
                    self.refreshStatusLights();
                    self.disableButtons();

                    self.displayStatus(self.remoteDevice.status.invalidDevice ? 'invalid_device' : 'error');
                },
                true
            );
        },
        'click .js-btn-stop': function () {
            var self = this;
            this.refreshActive = false;
            this.isStarting = false;
            this.isStopping = true;
            this.disableButtons();
            this.refreshStatusLights();
            this.displayStatus('stopping');
            this.remoteDevice.stopCommand(
                function () {
                    self.isStopping = false;
                    self.isStarting = false;
                    self.refreshActive = false;
                    self.refreshStatusLights();
                    self.displayStatus('not_connected');
                    self.disableButtons();
                },
                function () {
                    self.isStarting = false;
                    self.isStopping = false;
                    self.refreshActive = false;
                    self.displayStatus('error');
                    self.disableButtons();
                }
            );
        },
    },
    remoteDevice: undefined,
    template: require('components/devices/templates/controller/remote_control'),
    templateKnobHint: require('components/devices/templates/controller/remote_control_knob_hint'),
    imagePath: 'img/devices/remotecontrol/',
    maxMagnifyFactor: 3,

    ui: {
        deviceCasing: '#remote_device_casing',
        deviceDisplay: '.remote-device-display',
        deviceDisplayBmp: '#remote-device-display_bmp',
        deviceDisplaySym: '#remote-device-display_sym',
        btnRun: '.js-btn-run',
        btnStop: '.js-btn-stop',
        deviceProgButton: '.remote-device-button-prog',
        deviceTypeText: '.remote-device-type',
        remoteControl: '.remote-control',
        deviceContainer: '#remote_device_container',
        deviceKnobButton: 'button.remote-control-knob',
    },

    marginSmall: 10,
    startTimeout: 20000,
    refreshInterval: 90,
    lastRefresh: 0,
    refreshActive: false,
    isStarting: false,
    deviceView: {
        type: undefined,
        controls: {},
    },
    normalColor: '#333',
    forbiddenColor: '#f55',
    activeColor: '#5d5',
    readOnly: false,
    adminMode: false,
    knobButtons: [1, 10, 100],

    mouseKnobDown: function () {
        this.eventQueue.add(this.eventQueue.knobDown);
    },

    mouseKnobUp: function () {
        this.eventQueue.add(this.eventQueue.knobUp);
    },

    knobDown: function (onSuccess) {
        var self = this;
        this.ui.deviceKnobButton.css('color', self.activeColor);
        this.remoteDevice.command(
            {
                cmd: Consts.RemoteControlCmd.KnobDown,
            },
            function () {
                if (onSuccess) {
                    onSuccess();
                }
            }
        );
    },

    knobUp: function () {
        var self = this;
        this.ui.deviceKnobButton.css('color', self.normalColor);
        this.remoteDevice.command(
            {
                cmd: Consts.RemoteControlCmd.KnobUp,
            },
            function () {}
        );
    },

    knobSet: function (value) {
        var self = this;
        this.knobRotating = undefined;
        this.ui.deviceKnobButton.css('color', self.normalColor);
        this.remoteDevice.command(
            {
                cmd: Consts.RemoteControlCmd.KnobSet,
                value: value,
            },
            function () {}
        );
    },

    calculateClientHeight: function () {
        var totalHeight = $(window).height(); // window.screen.availHeight;
        var containerTop = $('.content > .container').offset().top;
        var footerHeight = $('.footer').outerHeight();

        var result = totalHeight - containerTop - footerHeight;
        if (this.ui.deviceCasing.length > 0) {
            result = result - this.ui.deviceCasing.offset().top;
        }

        return result;
    },

    disableButtons: function () {
        // when the this.ui is not connected with elements, wait and try later
        var self = this;
        if (!this.ui.btnRun.attr) {
            setTimeout(function () {
                self.disableButtons();
            }, 500);
            return;
        }
        this.ui.btnRun.attr('disabled', this.refreshActive || this.isStarting || this.isStopping);
        this.ui.btnStop.attr('disabled', !this.refreshActive || this.isStarting || this.isStopping);
    },

    onRender: function () {
        // first, let everything disappear
        this.eventQueue.owner = this;
        this.disableButtons();
        this.ui.deviceContainer.hide();
        this.isRemoved = false;

        this.setupResize();
        var self = this;

        setTimeout(function () {
            self.doRedraw();
            self.refresh(false, true);
        }, 1);
    },

    refresh: function (doActivate, firstCall) {
        var currentTime = new Date().getTime();
        var diff = currentTime - this.lastRefresh;
        if (diff < this.refreshInterval * 0.5) {
            // 50% tolerance - the timer doesn't have to run punctually
            return;
        }
        this.lastRefresh = currentTime;

        var self = this;
        if (doActivate) this.refreshActive = true;

        if (this.remoteDevice === undefined) this.remoteDevice = new RemoteDevice({ controller: this.model });

        var goOn = function () {
            if (self.remoteDevice.status.wantAbort) {
                self.refreshActive = false;
                self.disableButtons();
                self.doRedraw();
            }
            if (self.remoteDevice.status.invalidDevice) {
                self.refreshActive = false;
                self.isStarting = false;
                self.disableButtons();
                self.doRedraw();
            }
            self.refreshStatusLights();
            if (self.refreshActive) {
                var intervalBase = self.remoteDevice.status.timestampDiff / 2 || self.refreshInterval;
                intervalBase = Math.max(intervalBase, self.refreshInterval);

                var interval = intervalBase - new Date().getTime() + self.lastRefresh;
                interval = Math.max(interval, 1);
                interval = Math.min(interval, self.maxRefreshInterval);

                setTimeout(function () {
                    self.refresh();
                }, interval);
            }
        };

        if (!this.refreshActive) return;
        this.remoteDevice.update(
            function () {
                if (self.isRemoved) return;

                if (self.deviceView.type !== self.remoteDevice.content.device_type) {
                    self.setupDevice();
                }

                self.doRedraw();
                goOn();
            },
            function () {
                if (self.isRemoved) return;
                goOn();
            },
            firstCall
        );
    },

    refreshStatusLights: function () {
        this.statusBarView.statusData.lightClass = '';
        if (this.isStarting) this.statusBarView.statusData.lightClass = 'warning';
        if (this.remoteDevice.status.error || this.remoteDevice.status.isRetrying)
            this.statusBarView.statusData.lightClass = 'error';
        this.statusBarView.statusData.light = this.refreshActive ? this.remoteDevice.status.refresh : -1;
        this.statusBarView.statusData.spectatorCount = this.refreshActive && this.remoteDevice.status.spectatorCount;

        if (
            (this.remoteDevice.status.error || this.remoteDevice.status.isRetrying) &&
            this.refreshActive &&
            !this.isStarting
        ) {
            this.displayStatus('error_reconnecting', false);
        } else if (this.remoteDevice.status.error) this.displayStatus('error', false);
        else if (!this.isStarting && this.refreshActive) {
            if (this.remoteDevice.status.sending) this.displayStatus('sending', false);
            else this.displayStatus('connected', false);
        }

        if (this.remoteDevice.status.invalidDevice) {
            this.displayStatus('invalid_device', false);
        }

        this.statusBarView.render();
    },

    setupDevice: function () {
        if (!this.remoteDevice && !this.remoteDevice.content) return;

        var device = this.deviceView;
        var content = this.remoteDevice.content;
        var self = this;

        // create controls
        var setupModeSelectors = function () {
            if (device.controls.selector === undefined) device.controls.selector = [];

            var setupModeSelector = function (ms, idx) {
                if (device.controls.selector[idx] === undefined) {
                    device.controls.selector[idx] = {};

                    // 1. canvas
                    var canvas = document.createElement('canvas');
                    self.ui.deviceContainer.append(canvas);
                    device.controls.selector[idx].canvas = canvas;
                    $(canvas).data('ms', idx);

                    // show popup on click
                    $(canvas).on('click', function (e) {
                        idx = $(e.target).data('ms');
                        self.showModeSelectorDialog(idx);
                    });

                    // 2. image
                    var img = document.createElement('img');
                    self.ui.deviceContainer.append(img);
                    device.controls.selector[idx].img = img;

                    // 3. buttons
                    device.controls.selector[idx].buttons = self.createModeSelectorButtons(
                        content.selector[idx],
                        self.ui.deviceContainer,
                        idx
                    );
                    $(device.controls.selector[idx].buttons).on('click', function (e) {
                        var msIdx = $(e.target).data('ms');
                        var msPos = $(e.target).data('nr');
                        self.modeSelectorClick(msIdx, msPos);
                    });
                }
            };

            for (var i = 0; i < content.selector.length; i++) setupModeSelector(content.selector[i], i);
        };

        var setupKnob = function () {
            var mouseFromTouch = function (e) {
                if (e.touches.length === 0)
                    return {
                        target: e.target,
                        type: e.type,
                    };

                return {
                    target: e.target,
                    clientX: e.touches[0].clientX,
                    clientY: e.touches[0].clientY,
                    type: e.type,
                };
            };

            var addMouseEvent = function (e) {
                var toolipShown = false;
                var mouseStartX = e.clientX;
                var mouseStartY = e.clientY;
                var target = e.target;

                var mousemove = function (e) {
                    var dx = mouseStartX - e.clientX;
                    var dy = mouseStartY - e.clientY;

                    if (dx == 0 && dy == 0)
                        // no mouse move
                        return;

                    var diameterRecalc = (content.knob.size * content.display.currentWidth) / content.display.width;
                    var horizRatio = (e.clientX - mouseStartX) / diameterRecalc;

                    var ratio = (100 * Math.sqrt(dx * dx + dy * dy)) / diameterRecalc;
                    var value = ratio;
                    if (ratio < 30) value = 1;
                    else if (ratio < 70) value = ratio - 29;
                    else value = 3 * ratio - 29 - 140;

                    value = Math.max(Math.floor(value), 1);
                    value = Math.min(value, 99);

                    var isRotation = Math.abs(horizRatio) >= 0.1;

                    if (!toolipShown && value >= 1 && isRotation) {
                        self.ui.deviceKnobButton.tooltip('show');
                        toolipShown = true;
                    }

                    $(target)
                        .next('.tooltip')
                        .find('.tooltip-inner')
                        .html(
                            self.templateKnobHint({
                                rotateRight: horizRatio > 0,
                                rotateLeft: horizRatio < 0,
                                value: '' + Misc.leadingZero(value),
                            })
                        );
                    self.ui.deviceKnobButton.data('rotate-value', value);
                    if (value !== 0) {
                        self.knobRotating = (horizRatio < 0 ? -1 : 1) * value;
                        self.eventQueue.add(self.eventQueue.knobRotate, self.knobRotating);
                    }
                };

                var mouseup = function (e) {
                    if (e.preventDefault) e.preventDefault();
                    self.ui.deviceKnobButton.off('mousemove', mousemove);
                    self.ui.deviceKnobButton.off('mouseup', mouseup);
                    self.ui.deviceKnobButton.off('touchend', touchEnd);

                    if (toolipShown) {
                        self.ui.deviceKnobButton.tooltip('hide');
                    }

                    if (e.type === 'mouseup' || e.type == 'touchend') self.mouseKnobUp();
                };

                var touchMove = function (e) {
                    if (e.preventDefault) e.preventDefault();
                    mousemove(mouseFromTouch(e));
                };

                var touchEnd = function (e) {
                    if (e.preventDefault) e.preventDefault();
                    mouseup(mouseFromTouch(e));
                };

                self.ui.deviceKnobButton.on('mousemove', mousemove);
                self.ui.deviceKnobButton.on('mouseup mouseleave', mouseup);

                self.ui.deviceKnobButton[0].addEventListener('touchmove', touchMove);
                self.ui.deviceKnobButton[0].addEventListener('touchend', touchEnd);

                self.ui.deviceKnobButton.tooltip({
                    trigger: 'manual',
                    title: self.templateKnobHint({ rotateRight: true, value: 'x00' }),
                    html: true,
                });

                self.mouseKnobDown();
            };

            $(self.ui.deviceKnobButton).on('mousedown', function (e) {
                addMouseEvent(e);
            });
            $(self.ui.deviceKnobButton)[0].addEventListener('touchstart', function (e) {
                addMouseEvent(mouseFromTouch(e));
            });

            // create buttons
            device.controls.knob = { buttons: [] };
            for (var i = 0; i < self.knobButtons.length; i++) {
                var createButton = function (sideClass, dir) {
                    var btn = document.createElement('button');
                    self.ui.deviceContainer.append(btn);
                    $(btn).addClass('remote-device-knob-button');
                    $(btn).addClass(sideClass);
                    $(btn).data('step-count', self.knobButtons[i] * dir);
                    $(btn).css('z-index', self.knobButtons.length - i + 1);
                    device.controls.knob.buttons.push(btn);
                };

                createButton('knob-left', -1);
                createButton('knob-right', 1);
            }
        };

        setupModeSelectors();
        setupKnob();

        this.deviceView.type = this.remoteDevice.content.device_type;
    },

    createModeSelectorButtons: function (ms, target, idx) {
        var buttonArray = [];
        for (var i = 0; i <= ms.posTill - ms.posFrom; i++) {
            var btn = document.createElement('button');
            $(btn).data('nr', i + ms.posFrom);
            $(btn).data('ms', idx);
            target.append(btn);
            buttonArray[i] = btn;
        }

        return buttonArray;
    },

    setupResize: function () {
        if (!document.trovisRemoteControlContext) document.trovisRemoteControlContext = {};

        if (!document.trovisRemoteControlContext.isResize) {
            $(window).on('resize.remote-control', _.bind(this.doResize, this));
            document.trovisRemoteControlContext.isResize = true;
        }

        this.doResize();
    },

    doRedraw: function () {
        if (!this.remoteDevice || !this.remoteDevice.content) return;
        if (this.isRemoved) return;

        if (typeof this.ui.remoteControl == 'string') {
            this.bindUIElements();
            setTimeout(function () {
                this.doRedraw();
            }, 100);
            return;
        }

        // calculate the scaling
        var self = this;

        var ctrlWidth = this.ui.remoteControl.width();
        var screenHeightUsed = false;

        if (this.screenHeightChange[ctrlWidth]) {
            screenHeightUsed = true;
            ctrlWidth = this.screenHeightChange[ctrlWidth];
        }
        var clientWidth = ctrlWidth;
        var clientHeight = this.calculateClientHeight();
        var device = this.remoteDevice.content;
        var deviceView = this.deviceView;

        var deviceRatio = device.display.width / device.display.originalWidth;
        var basisWidth = device.casing.width / deviceRatio;
        var basisHeight = device.casing.height / deviceRatio;

        var magnifyFactor = Math.min(
            Math.min(Math.max(clientWidth / basisWidth, 1), Math.max(clientHeight / basisHeight, 1)),
            this.maxMagnifyFactor
        );
        var mobilePosY = 0;
        var scaleRatio = magnifyFactor / deviceRatio;

        device.display.currentWidth = device.display.width * scaleRatio;
        device.display.currentHeight = device.display.height * scaleRatio;

        // must the mobile design be used?
        var layoutMobile = 0;

        if (clientWidth <= this.mobileWidth) {
            layoutMobile = 1;
            _.each(device.selector, function (ms) {
                if (clientWidth <= device.display.currentWidth + ms.width * scaleRatio) layoutMobile = 1;
            });
        }

        this.mobileCorrection = layoutMobile ? Math.min(window.screen.availHeight / window.screen.availWidth, 1) : 1;

        // the display size can be corrected in the mobile design
        if (layoutMobile > 0) {
            magnifyFactor = (clientWidth / device.display.originalWidth) * this.mobileCorrection;
            device.display.currentWidth = magnifyFactor * device.display.originalWidth;
            device.display.currentHeight = magnifyFactor * device.display.originalHeight;
        }

        scaleRatio = magnifyFactor / deviceRatio;

        var displayCasing = function () {
            if (layoutMobile === 0) {
                self.ui.deviceCasing.show();
                self.ui.deviceCasing.attr('src', self.imagePath + device.casing.img);
                self.ui.deviceCasing.attr('width', device.casing.width * scaleRatio);
                self.ui.deviceCasing.attr('height', device.casing.height * scaleRatio);
            } else {
                self.ui.deviceCasing.hide();
            }
        };

        var displayScreen = function () {
            // screen position
            switch (layoutMobile) {
                case 0:
                    $(self.ui.deviceDisplay).removeClass('mobile');
                    $(self.ui.deviceDisplay).css('left', '' + device.display.x * scaleRatio + 'px');
                    $(self.ui.deviceDisplay).css('top', '' + device.display.y * scaleRatio + 'px');
                    break;
                case 1:
                    var leftCenter = (clientWidth - device.display.currentWidth) / 2;
                    $(self.ui.deviceDisplay).addClass('mobile');
                    $(self.ui.deviceDisplay).css('left', '' + leftCenter + 'px');
                    $(self.ui.deviceDisplay).css('top', '' + mobilePosY + 'px');
                    mobilePosY += device.display.currentHeight + self.marginSmall;
                    break;
            }

            var displayScreenSym = function (img) {
                $(self.ui.deviceDisplayBmp).hide();
                $(self.ui.deviceDisplaySym).show();
                $(self.ui.deviceDisplaySym).css('width', device.display.currentWidth);
                $(self.ui.deviceDisplaySym).css('height', device.display.currentHeight);
                var imgPath = self.imagePath + device.display.img[device.display.showMode].src;
                if ($(img).attr('data') != imgPath || device.display.lastDisplayWidth !== device.display.currentWidth) {
                    $(img).attr('data', imgPath);
                    device.display.lastDisplayWidth = device.display.currentWidth;
                }

                var doDisplay = function () {
                    if (!img || !img.contentDocument) return;

                    var d = img.contentDocument;
                    var colBase = 0;

                    if (device.device.data === null) return;

                    for (var i = 0; i < device.device.data.length; i++) {
                        var bit = 1;
                        var currentByte = device.device.data[i];

                        for (var j = 0; j < 8; j++) {
                            var col;
                            var row;

                            var dynPart = device.display.showMode == 1 ? 1 - Math.floor(j / 4) : Math.floor(j / 4);
                            col = colBase + dynPart;
                            row = j % 4;
                            var id = '' + col + '_' + row;
                            var el = null;
                            if (d) el = d.getElementById(id);
                            var opacity = (currentByte & bit) > 0 ? 1 : 0.02;

                            if (el !== null) el.setAttributeNS(null, 'opacity', opacity);

                            bit = bit << 1;
                        }
                        colBase += 2;
                    }
                };

                if (img && img.isLoaded) {
                    doDisplay();
                } else {
                    img.addEventListener('load', function () {
                        img.isLoaded = true;
                        doDisplay();
                    });
                }
            };

            var displayScreenBmp = function (cnvs) {
                $(self.ui.deviceDisplaySym).hide();
                $(self.ui.deviceDisplayBmp).show();
                $(self.ui.deviceDisplayBmp).attr('width', device.display.currentWidth);
                $(self.ui.deviceDisplayBmp).attr('height', device.display.currentHeight);
                var ctx = cnvs.getContext('2d');
                ctx.clearRect(0, 0, cnvs.width, cnvs.height);

                var pixelWidth = device.display.currentWidth / device.display.graphicWidth;
                var pixelHeight = device.display.currentHeight / device.display.graphicHeight;

                var x = 0;
                var y = 0;
                var colCount = 0;

                var getColor = function (c) {
                    switch (c) {
                        case 0:
                            return '#000000';
                        case 1:
                            return '3333231';
                        case 2:
                            return '#666462';
                        case 3:
                            return layoutMobile === 0 ? undefined : '#EEEEFF';
                    }
                };

                var drawByte = function (b, yy) {
                    for (var i = 0; i < 4; i++) {
                        var c = getColor(b & 3);
                        if (c !== undefined) {
                            ctx.fillStyle = c;
                            ctx.fillRect(x, yy, pixelWidth, pixelHeight);
                        }
                        yy += pixelHeight;
                        b = b >> 2;
                    }
                };

                for (var i = 0; i < device.device.data.length; i++) {
                    drawByte(device.device.data[i], y);
                    colCount++;
                    x += pixelWidth;
                    if (colCount >= device.display.graphicWidth) {
                        x = 0;
                        colCount = 0;
                        y = y + 4 * pixelHeight;
                    }
                }
            };

            if (device.device.data) {
                if (device.device.is_symbol) displayScreenSym(self.ui.deviceDisplaySym[0]);
                else displayScreenBmp(self.ui.deviceDisplayBmp[0]);
            }
        };

        var displayModeSelectors = function () {
            _.each(device.selector, function (ms, idx) {
                var centerX;
                var centerY;
                var imageWidth;

                if (layoutMobile === 0) {
                    imageWidth = ms.width * scaleRatio;
                    centerX = ms.x * scaleRatio;
                    centerY = ms.y * scaleRatio;
                } else {
                    imageWidth = clientWidth * 0.8 * self.mobileCorrection;
                    centerX = clientWidth / 2;
                    centerY = mobilePosY + imageWidth / 2;
                    mobilePosY += imageWidth;
                }

                self.displayModeSelector(
                    deviceView.controls.selector[idx].img,
                    deviceView.controls.selector[idx].canvas,
                    deviceView.controls.selector[idx].buttons,
                    centerX,
                    centerY,
                    imageWidth,
                    device,
                    ms
                );
            });

            mobilePosY += self.marginSmall;
        };

        var displayKnob = function () {
            if (self.readOnly || !self.refreshActive) {
                self.ui.deviceKnobButton.hide();
                _.each(deviceView.controls.knob.buttons, function (x) {
                    $(x).hide();
                });
                return;
            } else {
                self.ui.deviceKnobButton.show();
                _.each(deviceView.controls.knob.buttons, function (x) {
                    $(x).show();
                });
            }

            var size = device.knob.size * scaleRatio;
            var knobCenterX = device.knob.x * scaleRatio;
            var knobCenterY = device.knob.y * scaleRatio;

            if (layoutMobile > 0) {
                knobCenterX = clientWidth / 2;
                knobCenterY = size / 2 + mobilePosY;
            }

            var knobLeft = knobCenterX - size / 2;
            var knobTop = knobCenterY - size / 2;

            self.ui.deviceKnobButton.css('width', '' + size + 'px');
            self.ui.deviceKnobButton.css('height', '' + size + 'px');
            self.ui.deviceKnobButton.css('left', '' + knobLeft + 'px');
            self.ui.deviceKnobButton.css('top', '' + knobTop + 'px');
            self.ui.deviceKnobButton.css('border-radius', '' + size + 'px');

            // buttons
            var deg2rad = Math.PI / 180;
            var diffAngle = 22;
            var startAngle = 38;
            var startAngleRad = startAngle * deg2rad;
            var diffRad = diffAngle * deg2rad;
            var angle = startAngleRad;
            var width = size * (layoutMobile === 0 ? 1 : 1 / magnifyFactor);
            var height = size * (layoutMobile === 0 ? 0.35 : 0.25);

            for (var i = 0; i < deviceView.controls.knob.buttons.length; i += 2) {
                var positionButton = function (btn, dir) {
                    if (btn === undefined) return;

                    $(btn).css('width', '' + width + 'px');
                    $(btn).css('height', '' + height + 'px');

                    var x;
                    if (layoutMobile === 0) {
                        x = +knobCenterX - width / 2 + dir * Math.max(width * 1.05, dir * size);
                    } else {
                        x = +knobCenterX + dir * size * 1.1 + (dir == 1 ? -width : 0);
                        if (dir == -1) {
                            x = Math.min(x, (clientWidth - device.display.currentWidth) / 2);
                        } else {
                            x = Math.max(x, -width + (clientWidth + device.display.currentWidth) / 2);
                        }
                    }
                    var y = i * height * 0.55 + knobCenterY - size / 2;

                    $(btn).css('left', '' + x + 'px');
                    $(btn).css('top', '' + y + 'px');
                    $(btn).html(
                        self.templateKnobHint({
                            rotateRight: dir == 1,
                            rotateLeft: dir == -1,
                            value: self.knobButtons[i / 2],
                        })
                    );
                };

                positionButton(deviceView.controls.knob.buttons[i], -1);
                positionButton(deviceView.controls.knob.buttons[i + 1], +1);
                angle += diffRad;
            }

            mobilePosY = mobilePosY + size + self.marginSmall;
        };

        var displayProgButton = function () {
            if (device.prog && !self.readOnly && self.refreshActive) {
                var p = self.ui.deviceProgButton;
                p.show();
                var calc = function (p, k) {
                    if (k === undefined) k = 1;
                    return '' + device.prog[p] * k * scaleRatio + 'px';
                };

                if (layoutMobile > 0) {
                    var size = Math.max(self.mobileWidth, Math.min(clientWidth, clientHeight)) * 0.25;
                    p.css('left', '' + (clientWidth - size) / 2 + 'px');
                    p.css('top', '' + mobilePosY + 'px');
                    p.css('height', '' + size + 'px');
                    p.css('width', '' + size + 'px');
                    p.css('font-size', '' + 0.5 * size + 'px');
                    mobilePosY += size + self.marginSmall;
                } else {
                    p.css('left', calc('x'));
                    p.css('top', calc('y'));
                    p.css('height', calc('size'));
                    p.css('width', calc('size'));
                    p.css('font-size', calc('size', 0.5));
                }
            } else {
                self.ui.deviceProgButton.hide();
            }
        };

        var displayText = function () {
            var size = device.text.font * scaleRatio;
            if (layoutMobile === 0) {
                var x = device.text.x * scaleRatio;
                var y = device.text.y * scaleRatio;

                self.ui.deviceTypeText.css('left', '' + x + 'px');
                self.ui.deviceTypeText.css('top', '' + y + 'px');
                self.ui.deviceTypeText.css('font-size', '' + size + 'px');
                self.ui.deviceTypeText.html(device.device_type);
            } else {
                self.ui.deviceTypeText.css('left', '' + 0 + 'px');
                self.ui.deviceTypeText.css('top', '' + mobilePosY + 'px');
                self.ui.deviceTypeText.css('font-size', '' + size + 'px');
                self.ui.deviceTypeText.html(device.text.prefix + ' ' + device.device_type);
                mobilePosY += self.ui.deviceTypeText.outerHeight() + self.marginSmall;
            }
        };

        displayText();
        displayCasing();
        displayScreen();
        displayKnob();
        displayModeSelectors();
        displayProgButton();

        this.ui.deviceContainer.show();

        if (layoutMobile > 0) {
            self.ui.deviceContainer.css('min-height', '' + mobilePosY + 'px');
            if (clientWidth != this.ui.remoteControl.width()) {
                var w1 = clientWidth;
                var w2 = this.ui.remoteControl.width();
                self.screenHeightChange[Math.max(w1, w2)] = Math.min(w2, w1);
            } else {
                if (!screenHeightUsed) self.screenHeightChange[Math.max(w1, w2)] = {};
            }
        } else {
            self.ui.deviceContainer.css('min-height', '0px');
        }
    },

    remove: function () {
        this.isRemoved = true;
        if (document.trovisRemoteControlContext.isResize) {
            $(window).off('resize.remote-control');
            document.trovisRemoteControlContext = undefined;
        }
        this.deviceView.type = undefined;
        this.deviceView.controls = [];

        this.refreshActive = false;
    },

    displayModeSelector: function (img, canvas, buttons, centerX, centerY, imageWidth, device, ms, currentPos) {
        $(img).attr('src', this.imagePath + ms.img);
        $(img).attr('width', imageWidth);
        $(img).attr('height', imageWidth);
        $(img).addClass('remote_mode_selector');

        $(img).css('left', '' + (-imageWidth / 2 + centerX) + 'px');
        $(img).css('top', '' + (-imageWidth / 2 + centerY) + 'px');

        // 2. buttons
        var toRad = Math.PI / 180;
        var aTill = (ms.angleTill > ms.angleFrom ? 0 : 360) + ms.angleTill;
        var angleStep = ((aTill - ms.angleFrom) / (buttons.length - 1)) * toRad;
        var angle = ms.angleFrom * toRad;
        var k = 0.495; // relative length of the pointer
        var k2 = 0.165; // relative length of the "white part" of the pointer
        var k3 = 0.85; // relative distance of dots from the center point
        var k4 = 0.017; // relative size of dots
        var k5 = 0.385; // relative distance of buttons from the center point
        var k6 = 0.22; // relative size of the "disc" in the middle

        var self = this;

        var btnWidth = imageWidth / 5;
        var positionCenter = [];
        var crsr = this.refreshActive ? 'pointer' : 'not-allowed';

        _.each(buttons, function (b, idx) {
            positionCenter[idx] = {
                x: imageWidth * k5 * Math.sin(angle),
                y: imageWidth * k5 * -Math.cos(angle),
                angle: angle,
            };

            var x = centerX + positionCenter[idx].x - btnWidth / 2;
            var y = centerY + positionCenter[idx].y - btnWidth / 2;

            var $b = $(b);
            $b.addClass('remote_mode_selector');
            $b.addClass('point');
            $b.css('left', '' + x + 'px');
            $b.css('top', '' + y + 'px');
            $b.css('width', '' + btnWidth + 'px');
            $b.css('height', '' + btnWidth + 'px');
            $b.attr('disabled', !self.refreshActive);
            $b.css('cursor', crsr);
            angle += angleStep;
        });

        // 3. canvas
        var cs = $(canvas);
        cs.addClass('remote_mode_selector');
        cs.css('left', '' + (-imageWidth / 2 + centerX) + 'px');
        cs.css('top', '' + (-imageWidth / 2 + centerY) + 'px');
        cs.attr('width', imageWidth);
        cs.attr('height', imageWidth);
        cs.css('cursor', crsr);

        var ctx = canvas.getContext('2d');
        // button in the center
        ctx.beginPath();
        ctx.arc(imageWidth / 2, imageWidth / 2, k6 * imageWidth, 0, Math.PI * 2);
        ctx.fillStyle = self.normalColor;
        ctx.fill();

        // line connecting dots
        if (ms.modePosFrom) {
            var angleFrom = positionCenter[ms.modePosTill + 1 - ms.posFrom].angle - Math.PI / 2;
            var angleTill = positionCenter[ms.posTill - ms.posFrom].angle - Math.PI / 2;
            ctx.beginPath();
            ctx.arc(imageWidth / 2, imageWidth / 2, imageWidth * k3 * k5, angleFrom, angleTill);
            ctx.lineWidth = 2;
            ctx.strokeStyle = '#000';
            ctx.stroke();
        }

        // dots
        _.each(positionCenter, function (p, id) {
            var isNormalColor =
                self.adminMode || (!self.readOnly && self.remoteDevice.allowModeSelect(ms, id + ms.posFrom));
            var color = isNormalColor ? self.normalColor : self.forbiddenColor;
            if (ms.currentPos == id + ms.posFrom) {
                color = self.activeColor;
            }

            ctx.beginPath();
            ctx.arc(p.x * k3 + imageWidth / 2, p.y * k3 + imageWidth / 2, imageWidth * k4, 0, Math.PI * 2);
            ctx.fillStyle = color;
            ctx.fill();
        });

        // selector
        var color = '#fff';
        if (currentPos === undefined) {
            currentPos = ms.currentPos;

            if (ms.lastVirtualSelected) {
                var diffTime = new Date().getTime() - ms.lastVirtualSelectedTime.getTime();
                if (diffTime <= 1000 * 30 && ms.lastVirtualSelected != currentPos) {
                    currentPos = ms.lastVirtualSelected;
                    color = '#999';

                    if (ms.lastVirtualSelectedTimeError !== undefined) {
                        color = '#F33';
                        if (diffTime <= 1000 * 5) {
                            ms.lastVirtualSelected = undefined;
                            ms.lastVirtualSelectedTime = undefined;
                        }
                    }
                } else {
                    ms.lastVirtualSelected = undefined;
                    ms.lastVirtualSelectedTime = undefined;
                }
            }
        }

        var pt = positionCenter[currentPos - ms.posFrom];
        if (pt) {
            var dv = {
                x: pt.x,
                y: pt.y,
            };

            var w = imageWidth / 18;
            ctx.beginPath();
            ctx.strokeStyle = '#000';
            ctx.lineCap = 'round';
            ctx.lineWidth = w * 2;
            ctx.moveTo(imageWidth / 2 - dv.x * k, imageWidth / 2 - dv.y * k);
            ctx.lineTo(imageWidth / 2 + dv.x * k, imageWidth / 2 + dv.y * k);
            ctx.stroke();

            ctx.beginPath();
            ctx.lineWidth = w;
            ctx.strokeStyle = color;
            ctx.moveTo(imageWidth / 2 + dv.x * k2, imageWidth / 2 + dv.y * k2);
            ctx.lineTo(imageWidth / 2 + dv.x * k, imageWidth / 2 + dv.y * k);
            ctx.stroke();
        }
    },

    modeSelectorClick: function (msIdx, msPos) {
        var self = this;
        if (
            !this.refreshActive ||
            this.readOnly ||
            (!this.adminMode && !this.remoteDevice.allowModeSelect(undefined, msPos, msIdx))
        ) {
            return;
        }

        this.remoteDevice.content.selector[msIdx].lastVirtualSelected = msPos;
        this.remoteDevice.content.selector[msIdx].lastVirtualSelectedTime = new Date();
        this.remoteDevice.content.selector[msIdx].lastVirtualSelectedTimeError = undefined;
        this.doRedraw();

        this.remoteDevice.command(
            {
                cmd: Consts.RemoteControlCmd.ModeSelector,
                sel: msIdx,
                value: msPos,
            },
            undefined,
            function (err) {
                self.remoteDevice.content.selector[msIdx].lastVirtualSelectedTimeError = new Date();
                self.remoteDevice.content.selector[msIdx].lastVirtualSelectedTime = new Date();
                self.doRedraw();
            }
        );
    },

    doResize: function () {
        var self = this;
        setTimeout(function () {
            self.doRedraw();
            setTimeout(function () {
                self.doRedraw();
            }, 200);
        }, 200);
    },

    showModeSelectorDialog: function (idx) {
        if (this.readOnly || !this.refreshActive) return;
        var self = this;
        var dlg = new ModeSelectorView({
            ownerView: this,
            adminMode: this.adminMode,
            modeSelectorIdx: idx,
            remoteDevice: this.remoteDevice,
            onSelected: function (option) {
                self.modeSelectorClick(idx, option);
            },
        });

        App.showModal(dlg);
    },

    setPermission: function (permissions) {
        var accessMode = permissions.get(Consts.Permissions.HandlingRemote);
        this.adminMode = AppState.user.get('is_admin');
        this.readOnly = accessMode === true;
    },

    displayStatus: function (message, doRender) {
        var msg = this.getStatusMessages(message);
        if (msg) {
            this.statusBarView.statusData.statusClass = msg.labelClass;
            this.statusBarView.statusData.statusText = msg.text;
            if (doRender || doRender === undefined) {
                this.statusBarView.render();
            }
        }
    },

    onShow: function () {
        if (this.statusBarView == null) {
            this.statusBarView = new RemoteControlStatusView();
            this.showChildView('statusBar', this.statusBarView);
        }
        this.displayStatus('not_connected');
    },
});

module.exports = RemoteControlView;
